module.exports = __webpack_public_path__ + "static/media/companies-icon-2.d66e62da.svg";